import "./tailwind.css";
import "@fontsource-variable/work-sans";
import "@fontsource-variable/figtree";
import "@fontsource/aileron";
import "@fontsource/poppins";
import "@fontsource/paytone-one";
import "@fontsource/outfit";
import "@fontsource/cabin";

import { Links, Meta, Outlet, Scripts, ScrollRestoration } from "react-router";

import { GeneralErrorBoundary } from "~/components/error-boundary";
import type { LinksFunction } from "react-router";
import { Toaster } from "sonner";
import { useNonce } from "./hooks/use-nonce";

export const links: LinksFunction = () => [];

export function Layout({ children }: { children: React.ReactNode }) {
  const nonce = useNonce();
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body suppressHydrationWarning={true}>
        <script
          nonce={nonce}
          defer
          src="https://cloud.umami.is/script.js"
          data-website-id="387b12c6-4515-4489-898e-dec17084164f"
        />
        {children}
        <Toaster position="top-center" />
        <ScrollRestoration nonce={nonce} />
        <Scripts nonce={nonce} />
      </body>
    </html>
  );
}

export default function App() {
  return <Outlet />;
}

export const ErrorBoundary = GeneralErrorBoundary;
